import React, { useEffect, useState } from "react";
import { app } from "./firebaseConfig";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const auth = getAuth(app);
const db = getFirestore(app);

interface UserStats {
  name: string;
  email: string;
  lastAccess: number;
  activate?: ActivationStats;
}

interface ActivationStats {
  [product: string]: {
    activatedDate: number;
    code: string;
  };
}

export default function ActivateCode() {
  const [user, setUser] = useState(auth.currentUser);
  const [stats, setStats] = useState<UserStats | null>(null);
  const [productOptions, setProductOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setUser(user);
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data() as UserStats;
          setStats(userData);

          // Fetch achievement details from the server
          fetch(`${process.env.PUBLIC_URL}/list.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          })
            .then(response => response.json())
            .then(res => {
              setProductOptions(res);
            });
        }
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const authActivateCode = async () => {
    if (loading) return; // 連続実行防止
    setLoading(true);

    const activateProduct = document.getElementById("activate-product") as HTMLSelectElement;
    const activateCode = document.getElementById("activation-code") as HTMLInputElement;
    try {
      if (!user) {
        alert("ログインしてください。");
      } else if (user && activateProduct.selectedIndex > 0 && activateCode.value.length === 6) {
        await fetch("https://bad-assort.com/api/register-activate-code", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: user?.uid,
            userEmail: stats?.email,
            productName: activateProduct.value,
            timestamp: Date.now(),
            code: activateCode.value.toUpperCase(),
          }),
        })
          .then(response => response.json())
          .then(data =>
            alert(data.success
              ? "アクティベーションコードの入力を受け付けました。\nアカウントのアクティベーション状況を確認するにはページを更新してください。"
              : "アクティベーションコードの受付に失敗しました。入力内容をお確かめください。"));
      } else {
        alert("入力に不備があります。");
      }
    } catch (error) {
      console.error("エラー:", error)
    } finally {
      setLoading(false);
      activateCode.value = "";
    }
  };

  return <div>
    <h2>アクティベーションコード入力フォーム</h2>
    <div id="code-content">
      <ul>
        <li>事前に<a href="https://store.bad-assort.com/">Bad Assort 公式ストア</a>で対応する商品のコードをお買い求めください。</li>
        <li>アクティベーションコードは決済完了より5分以内にメールで送信されます。</li>
        <li>ご購入時に使用したメールアドレスと異なるメールアドレスのアカウントではコードを使用できません。</li>
        <li>英語のI（アイ）,O（オー）は使用しません。</li>
        <li>しばらく時間が経ってもコードが送られてこない場合や、コードを入力してもアクティベーションが実行されない場合は、お手数ですが<a href="https://bad-assort.com/%e3%81%8a%e5%95%8f%e3%81%84%e5%90%88%e3%82%8f%e3%81%9b%e3%83%95%e3%82%a9%e3%83%bc%e3%83%a0/">お問い合わせフォーム</a>よりご連絡ください。</li>
      </ul>
      <form id="form-inputs">
        <table>
          <tr>
            <th><p>購入アイテム</p></th>
            <td>
              <select id="activate-product">
                <option>-選択してください-</option>
                {productOptions.map((productName) => {
                  return <option value={productName}>{productName}</option>
                })}
              </select>
            </td>
          </tr>
          <tr>
            <th><p>コード</p></th>
            <td><input type="text" id="activation-code" placeholder="******" maxLength={6}></input></td>
          </tr>
        </table>

        <button type="button" onClick={authActivateCode} disabled={loading}>{loading ? "処理中です..." : "認証"}</button>
      </form>
    </div>
    {user ?
      <>
        <p>アカウントのアクティベーション状況</p>
        <table id="activation-map">
          {productOptions.map((productName) => {
            return <tr key={productName}><th>{productName}</th>{stats?.activate?.hasOwnProperty(productName) ? <td style={{ color: "var(--dark-accent)", fontSize: "0.8em" }}>アンロック済</td> : <td style={{ color: "gray", fontSize: "0.7em" }}>未購入</td>}</tr>;
          })}
        </table></>
      :
      <></>}
  </div>;
}
